import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { NextSeo } from "next-seo";

import Header from "../../Header";
import Footer from "../../Footer";
import SideMenu from "../../SideMenu";
import LastUpdate from "../../LastUpdate";
import { CardList } from "../../../src/components/molecules";
import { NavigationBar } from "../../../src/components/atoms";
import { useRouter } from "next/router";
import { Colors, Constants, Fonts, Values } from "../../../src/config";
import slugify from "slugify";
import moment from "moment";
import Head from "next/head";
import { getClass } from "../../../src/helpers/formatHelpers";
import { VenueDao } from "../../../src/DAO";
import {
  ActivityIndicator,
  StyleSheet,
  Text,
  TouchableOpacity,
} from "react-native-web";

const GuideType = (props) => {
  const { t } = useTranslation();
  const {
    categoryType,
    listDataCountry,
    listDataState,
    listDataCity,
    listDataFilter,
    listData,
    countListData,
    continentSelected,
    countrySelected,
    citySelected,
    typeSelected,
    stateSelected,
    paramsFinal,
  } = props;

  const router = useRouter();

  const [sideMenuShow, setSideMenuShow] = useState(false);
  const [sideMenuHeaderShow, setSideMenuHeaderShow] = useState(false);
  const [isMobileVersion, setIsMobileVersion] = useState(false);
  const [items, setItems] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [lastPageCount, setLastPageCount] = useState(0);
  const [pageIndex, setPageIndex] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const isShowLoadMore = items.length < totalCount;
  const countries = listDataCountry;
  const states = listDataState;
  const cities = listDataCity;
  const types = listDataFilter;
  const countryData = countries?.find(
    (i) => slugify(i.countryName?.toLowerCase()) === countrySelected
  );
  const cityData = cities?.find(
    (i) =>
      slugify(i.cityName?.toLowerCase()) ===
      (process.env.NEXT_PUBLIC_APP_NAME == "SpaClub" ||
      process.env.NEXT_PUBLIC_APP_NAME == "Beachful" ||
      process.env.NEXT_PUBLIC_APP_NAME == "Castlepedia" ||
      process.env.NEXT_PUBLIC_APP_NAME == "LuxResort Club" ||
      process.env.NEXT_PUBLIC_APP_NAME == "AparthotelClub" ||
      process.env.NEXT_PUBLIC_APP_NAME == "Zoopedia" ||
      process.env.NEXT_PUBLIC_APP_NAME == "Parkful" ||
      process.env.NEXT_PUBLIC_APP_NAME == "WorldCasino"
        ? citySelected?.replace("-city", "")
        : citySelected)
  );
  const stateData = states?.find(
    (i) =>
      slugify(i.stateName?.toLowerCase()) ===
      stateSelected?.replace("-state", "")
  );
  const typeData = types?.find(
    (i) =>
      slugify(i?.filterName?.toLowerCase()) ===
      typeSelected
        ?.replace(
          `-${
            process.env.NEXT_PUBLIC_APP_NAME == "Vybeful"
              ? "clubs"
              : process.env.NEXT_PUBLIC_APP_NAME == "RooftopClub"
              ? "rooftops"
              : process.env.NEXT_PUBLIC_APP_NAME == "Cocktayl"
              ? "cocktail-bars"
              : process.env.NEXT_PUBLIC_APP_NAME == "SpaClub"
              ? "spas"
              : process.env.NEXT_PUBLIC_APP_NAME == "Beachful"
              ? "beach-clubs"
              : process.env.NEXT_PUBLIC_APP_NAME == "PrefabWorld"
              ? "prefab-homes-manufacturers"
              : process.env.NEXT_PUBLIC_APP_NAME == "Zoopedia"
              ? "zoos-animal-parks"
              : process.env.NEXT_PUBLIC_APP_NAME == "Parkful"
              ? "amusement-parks"
              : process.env.NEXT_PUBLIC_APP_NAME == "WorldCasino"
              ? "casinos"
              : process.env.NEXT_PUBLIC_APP_NAME == "Castlepedia"
              ? "castles"
              : process.env.NEXT_PUBLIC_APP_NAME == "LuxResort Club"
              ? "luxury resorts"
              : process.env.NEXT_PUBLIC_APP_NAME == "AparthotelClub"
              ? "aparthotels"
              : process.env.NEXT_PUBLIC_APP_NAME == "Festicket"
              ? "festivals"
              : "clubs"
          }`,
          ""
        )
        // RooftopClub
        ?.replace("rooftop-", "")
        ?.replace("bars", "bar")
        ?.replace("restaurants", "restaurant")
        ?.replace("pools", "pool")
        // SpaClub
        ?.replace("day", "day-spa")
        ?.replace("destination", "destination-spa")
        ?.replace("thermal", "thermal-spa")
        ?.replace("hotel", "hotel-spa")
        ?.replace("club", "club-spa")
        ?.replace("medical", "medical-spa")
        // Zoopedia
        ?.replace("zoos", "zoo")
        ?.replace("wildlife-parks", "wildlife-park")
        ?.replace("animal-sanctuaries", "animal-sanctuary")
        ?.replace("aquariums", "aquarium")
        ?.replace("marine-mammal-parks", "marine-mammal-park")
        ?.replace("penguinariums", "penguinarium")
        ?.replace("dolphinariums", "dolphinarium")
        ?.replace("aviaries", "aviary")
        ?.replace("nocturnal-houses", "nocturnal-house")
        ?.replace("petting-zoos", "petting-zoo")
        ?.replace("animal-theme-parks", "animal-theme-park")
        ?.replace("reptilariums", "reptilarium")
        ?.replace("herpetariums", "herpetarium")
        ?.replace("serpentariums", "serpentarium")
        ?.replace("farms", "farm")
        ?.replace("oceanariums", "oceanarium")
        // Parkful
        ?.replace("theme-parks", "theme-park")
        ?.replace("waterparks", "waterpark")
  );
  const metaTitle = `${
    (categoryType === Constants.categoryType.CATEGORY_ZOO ||
      categoryType === Constants.categoryType.CATEGORY_PARKFUL) &&
    typeData?.filterName !== "Best"
      ? ""
      : typeData &&
        typeData?.filterName !== "Pool" &&
        typeData?.filterName !== "Bar" &&
        typeData?.filterName !== "Restaurant"
      ? typeData?.filterName
          ?.replace("All", "")
          ?.replace("Day Spa", "Day")
          ?.replace("Destination Spa", "Destination")
          ?.replace("Thermal Spa", "Thermal")
          ?.replace("Hotel Spa", "Hotel")
          ?.replace("Club Spa", "Club")
          ?.replace("Medical Spa", "Medical")
          ?.replace("Aviary", "Aviaries") + " "
      : ""
  }${
    process.env.NEXT_PUBLIC_APP_NAME == "Vybeful"
      ? "Clubs"
      : process.env.NEXT_PUBLIC_APP_NAME == "RooftopClub"
      ? typeData?.filterName === "Pool" ||
        typeData?.filterName === "Bar" ||
        typeData?.filterName === "Restaurant"
        ? "Rooftop"
        : "Rooftops"
      : process.env.NEXT_PUBLIC_APP_NAME == "Cocktayl"
      ? "Cocktail Bars"
      : process.env.NEXT_PUBLIC_APP_NAME == "SpaClub"
      ? "Spas"
      : process.env.NEXT_PUBLIC_APP_NAME == "Beachful"
      ? "Beach Clubs"
      : process.env.NEXT_PUBLIC_APP_NAME == "PrefabWorld"
      ? "Prefab homes manufacturers"
      : process.env.NEXT_PUBLIC_APP_NAME == "Zoopedia"
      ? typeData?.filterName === "All"
        ? "Zoos & Animal Parks"
        : ""
      : process.env.NEXT_PUBLIC_APP_NAME == "Parkful"
      ? typeData?.filterName === "All" || typeData?.filterName === "Best"
        ? "Amusement Parks"
        : ""
      : process.env.NEXT_PUBLIC_APP_NAME == "WorldCasino"
      ? "Casinos"
      : process.env.NEXT_PUBLIC_APP_NAME == "Castlepedia"
      ? "Castles"
      : process.env.NEXT_PUBLIC_APP_NAME == "LuxResort Club"
      ? "Resorts"
      : process.env.NEXT_PUBLIC_APP_NAME == "AparthotelClub"
      ? "Aparthotels"
      : process.env.NEXT_PUBLIC_APP_NAME == "Festicket"
      ? "Festivals"
      : "Clubs"
  } ${
    (categoryType === Constants.categoryType.CATEGORY_ZOO ||
      categoryType === Constants.categoryType.CATEGORY_PARKFUL) &&
    typeData?.filterName !== "Best" &&
    typeData?.filterName !== "All"
      ? typeData?.filterName !== "All" &&
        typeData?.filterName !== "Aviary" &&
        typeData?.filterName !== "Animal sanctuary" &&
        typeData?.filterName !== "Basic" &&
        typeData?.filterName !== "Premium" &&
        typeData?.filterName !== "Luxury" &&
        typeData?.filterName !== "Best"
        ? typeData?.filterName + "s "
        : typeData?.filterName
            ?.replace("Aviary", "Aviaries")
            ?.replace("Animal sanctuary", "Animal sanctuaries") + " "
      : typeData &&
        (typeData?.filterName === "Pool" ||
          typeData?.filterName === "Bar" ||
          typeData?.filterName === "Restaurant")
      ? typeData?.filterName?.replace("All", "")?.toLowerCase() + "s "
      : ""
  }${
    cityData?.cityName || stateData?.stateName || countryData?.countryName || ""
  }${
    ((categoryType === Constants.categoryType.CATEGORY_ZOO ||
      categoryType === Constants.categoryType.CATEGORY_PARKFUL ||
      categoryType === Constants.categoryType.CATEGORY_CASINO) &&
      continentSelected === "world") ||
    (categoryType === Constants.categoryType.CATEGORY_PREFAB_COMPANY &&
      countrySelected === "world")
      ? "World"
      : ""
  }`;
  const metaDescription = `Discover all the ${
    categoryType === Constants.categoryType.CATEGORY_RESORT ? "luxury " : ""
  }${
    (categoryType === Constants.categoryType.CATEGORY_ZOO ||
      categoryType === Constants.categoryType.CATEGORY_PARKFUL) &&
    typeData?.filterName !== "Best"
      ? ""
      : typeData &&
        typeData?.filterName !== "Pool" &&
        typeData?.filterName !== "Bar" &&
        typeData?.filterName !== "Restaurant"
      ? typeData?.filterName
          ?.replace("All", "")
          ?.replace("Day Spa", "Day")
          ?.replace("Destination Spa", "Destination")
          ?.replace("Thermal Spa", "Thermal")
          ?.replace("Hotel Spa", "Hotel")
          ?.replace("Club Spa", "Club")
          ?.replace("Medical Spa", "Medical")
          ?.replace("Aviary", "Aviaries")
          ?.toLowerCase() + " "
      : ""
  }${
    process.env.NEXT_PUBLIC_APP_NAME == "Vybeful"
      ? "clubs"
      : process.env.NEXT_PUBLIC_APP_NAME == "RooftopClub"
      ? typeData &&
        (typeData?.filterName === "Pool" ||
          typeData?.filterName === "Bar" ||
          typeData?.filterName === "Restaurant")
        ? "rooftop"
        : "rooftops"
      : process.env.NEXT_PUBLIC_APP_NAME == "Cocktayl"
      ? "cocktail bars"
      : process.env.NEXT_PUBLIC_APP_NAME == "SpaClub"
      ? "spas"
      : process.env.NEXT_PUBLIC_APP_NAME == "Beachful"
      ? "beach clubs"
      : process.env.NEXT_PUBLIC_APP_NAME == "PrefabWorld"
      ? "prefab homes manufacturers"
      : process.env.NEXT_PUBLIC_APP_NAME == "Zoopedia"
      ? typeData?.filterName === "All"
        ? "zoos & animal parks"
        : ""
      : process.env.NEXT_PUBLIC_APP_NAME == "Parkful"
      ? typeData?.filterName === "All" || typeData?.filterName === "Best"
        ? "amusement parks"
        : ""
      : process.env.NEXT_PUBLIC_APP_NAME == "WorldCasino"
      ? "casinos"
      : process.env.NEXT_PUBLIC_APP_NAME == "Castlepedia"
      ? "castles"
      : process.env.NEXT_PUBLIC_APP_NAME == "LuxResort Club"
      ? "resorts"
      : process.env.NEXT_PUBLIC_APP_NAME == "AparthotelClub"
      ? "aparthotels"
      : process.env.NEXT_PUBLIC_APP_NAME == "Festicket"
      ? "festivals"
      : "clubs"
  } ${
    (categoryType === Constants.categoryType.CATEGORY_ZOO ||
      categoryType === Constants.categoryType.CATEGORY_PARKFUL) &&
    typeData?.filterName !== "Best" &&
    typeData?.filterName !== "All"
      ? typeData?.filterName !== "All" &&
        typeData?.filterName !== "Aviary" &&
        typeData?.filterName !== "Animal sanctuary" &&
        typeData?.filterName !== "Basic" &&
        typeData?.filterName !== "Premium" &&
        typeData?.filterName !== "Luxury" &&
        typeData?.filterName !== "Best"
        ? typeData?.filterName?.toLowerCase() + "s "
        : typeData?.filterName
            ?.replace("Aviary", "Aviaries")
            ?.replace("Animal sanctuary", "Animal sanctuaries")
            ?.toLowerCase() + " "
      : typeData &&
        (typeData?.filterName === "Pool" ||
          typeData?.filterName === "Bar" ||
          typeData?.filterName === "Restaurant")
      ? typeData?.filterName?.replace("All", "")?.toLowerCase() + "s "
      : ""
  }${
    ((categoryType === Constants.categoryType.CATEGORY_ZOO ||
      categoryType === Constants.categoryType.CATEGORY_PARKFUL) &&
      continentSelected === "world") ||
    (categoryType === Constants.categoryType.CATEGORY_PREFAB_COMPANY &&
      countrySelected === "world")
      ? "around the world "
      : "in " +
        (cityData?.cityName ||
          stateData?.stateName ||
          countryData?.countryName ||
          "") +
        " "
  }with our guide.`;
  const updatedAt = moment().startOf("week").add("2", "days").toISOString();
  const canonicalURL = `https://${process.env.NEXT_PUBLIC_WWW_BASE_URL}/guides${
    continentSelected ? `/${continentSelected}` : ""
  }${countrySelected ? `/${countrySelected}` : ""}${
    stateSelected ? `/${stateSelected}` : ""
  }${citySelected ? `/${citySelected}` : ""}${
    typeSelected ? `/${typeSelected}` : ""
  }`;

  useEffect(() => {
    setIsMobileVersion(Values.deviceWidth < 640);
  }, [Values.deviceWidth]);

  const onLoad = async (page = 0) => {
    if (isLoading) return;
    setIsLoading(true);
    VenueDao.find({ ...paramsFinal, pageSize: 100, pageIndex: page })
      .then((result) => {
        if (page == 0) {
          setItems(result.data);
        } else {
          setItems([...items, ...result.data]);
        }
        setLastPageCount(result.data.length);
        setTotalCount(result.totalCount);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    onLoad();
  }, []);

  const onLoadMore = () => {
    if (lastPageCount == 100 && !isLoading) {
      setPageIndex(pageIndex + 1);
      onLoad(pageIndex + 1);
    }
  };

  return (
    <div>
      <Head>
        <script
          key="structured-data"
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "WebPage",
              "@id": canonicalURL,
              url: canonicalURL,
              name: metaTitle,
              dateModified: updatedAt,
            }),
          }}
        />
      </Head>
      <NextSeo
        noindex={
          (process.env.NEXT_PUBLIC_APP_NAME === "WorldCasino" &&
            (typeData?.filterName === "Basic" ||
              typeData?.filterName === "Premium" ||
              typeData?.filterName === "Luxury")) ||
          (process.env.NEXT_PUBLIC_APP_NAME === "Beachful" &&
            (typeData?.filterName === "Party" ||
              typeData?.filterName === "Vibey" ||
              typeData?.filterName === "Relax" ||
              typeData?.filterName === "Family")) ||
          (process.env.NEXT_PUBLIC_APP_NAME === "SpaClub" &&
            (typeData?.filterName === "Day Spa" ||
              typeData?.filterName === "Destination Spa" ||
              typeData?.filterName === "Thermal Spa" ||
              typeData?.filterName === "Hotel Spa" ||
              typeData?.filterName === "Club Spa" ||
              typeData?.filterName === "Medical Spa" ||
              typeData?.filterName === "Adults Only" ||
              typeData?.filterName === "Luxury" ||
              typeData?.filterName === "Rooftop" ||
              typeData?.filterName === "Basement"))
        }
        nofollow={
          (process.env.NEXT_PUBLIC_APP_NAME === "WorldCasino" &&
            (typeData?.filterName === "Basic" ||
              typeData?.filterName === "Premium" ||
              typeData?.filterName === "Luxury")) ||
          (process.env.NEXT_PUBLIC_APP_NAME === "Beachful" &&
            (typeData?.filterName === "Party" ||
              typeData?.filterName === "Vibey" ||
              typeData?.filterName === "Relax" ||
              typeData?.filterName === "Family")) ||
          (process.env.NEXT_PUBLIC_APP_NAME === "SpaClub" &&
            (typeData?.filterName === "Day Spa" ||
              typeData?.filterName === "Destination Spa" ||
              typeData?.filterName === "Thermal Spa" ||
              typeData?.filterName === "Hotel Spa" ||
              typeData?.filterName === "Club Spa" ||
              typeData?.filterName === "Medical Spa" ||
              typeData?.filterName === "Adults Only" ||
              typeData?.filterName === "Luxury" ||
              typeData?.filterName === "Rooftop" ||
              typeData?.filterName === "Basement"))
        }
        title={`${metaTitle} - ${process.env.NEXT_PUBLIC_APP_NAME}`}
        description={metaDescription}
        canonical={canonicalURL}
        openGraph={{
          type: "website",
          locale: "en_EN",
          url: canonicalURL,
          title: `${metaTitle} - ${process.env.NEXT_PUBLIC_APP_NAME}`,
          description: metaDescription,
          images: [
            {
              url: `https://${process.env.NEXT_PUBLIC_WWW_BASE_URL}${process.env.NEXT_PUBLIC_BANNER_IMAGE}`,
              width: 1200,
              height: 630,
              alt: `${process.env.NEXT_PUBLIC_APP_NAME}${process.env.NEXT_PUBLIC_APP_SLOGAN}`,
              type: "image/png",
            },
          ],
          siteName: `${process.env.NEXT_PUBLIC_APP_NAME}${process.env.NEXT_PUBLIC_APP_SLOGAN}`,
        }}
      />
      <Header setSideMenuShow={setSideMenuShow} />

      <SideMenu
        sideMenuShow={sideMenuShow}
        setSideMenuShow={setSideMenuShow}
        sideMenuHeaderShow={sideMenuHeaderShow}
        setSideMenuHeaderShow={setSideMenuHeaderShow}
      />

      <div className={`${getClass("background", true)}`}>
        <div
          className={`mx-auto relative ${
            isMobileVersion ? "" : "wrapper pt-[30px]"
          } pb-[130px]`}>
          <div className="max-w-1160px min-h-screen flex-1 mx-auto">
            <NavigationBar
              title={metaTitle}
              customStyle={{ marginTop: 0 }}
              isMobileVersion={isMobileVersion}
              onBackPressed={() =>
                router.push(
                  `/guides${continentSelected ? `/${continentSelected}` : ""}${
                    countrySelected ? `/${countrySelected}` : ""
                  }${
                    stateSelected &&
                    process.env.NEXT_PUBLIC_APP_NAME !== "PrefabWorld" &&
                    process.env.NEXT_PUBLIC_APP_NAME !== "Castlepedia" &&
                    process.env.NEXT_PUBLIC_APP_NAME !== "LuxResort Club" &&
                    process.env.NEXT_PUBLIC_APP_NAME !== "AparthotelClub"
                      ? `/${stateSelected}`
                      : ""
                  }${
                    citySelected &&
                    process.env.NEXT_PUBLIC_APP_NAME !== "Castlepedia" &&
                    process.env.NEXT_PUBLIC_APP_NAME !== "LuxResort Club" &&
                    process.env.NEXT_PUBLIC_APP_NAME !== "AparthotelClub"
                      ? `/${citySelected}`
                      : ""
                  }`
                )
              }
            />
            <div className="flex flex-row justify-center items-center">
              <div
                className={`flex flex-col justify-center items-center border ${getClass(
                  "border-black",
                  true
                )} px-[10px] py-[5px] rounded-full ${getClass(
                  "text-white",
                  true
                )} font-regular sm:text-base text-xs text-center mb-[30px]`}>
                <div>
                  <span className={`${getClass("text-gray2")}`}>
                    {countListData}
                  </span>
                  &nbsp;
                  {categoryType === Constants.categoryType.CATEGORY_VENUE
                    ? "Clubs"
                    : categoryType ===
                      Constants.categoryType.CATEGORY_VENUE_COCKTAIL
                    ? "Bars"
                    : categoryType === Constants.categoryType.CATEGORY_ROOFTOP
                    ? "Rooftops"
                    : categoryType === Constants.categoryType.CATEGORY_SPA
                    ? "Spas"
                    : categoryType ===
                      Constants.categoryType.CATEGORY_VENUE_BEACHFUL
                    ? "Beach Clubs"
                    : categoryType ===
                      Constants.categoryType.CATEGORY_PREFAB_COMPANY
                    ? "Companies"
                    : categoryType === Constants.categoryType.CATEGORY_CASINO
                    ? "Casinos"
                    : categoryType === Constants.categoryType.CATEGORY_CASTLE
                    ? "Castles"
                    : categoryType === Constants.categoryType.CATEGORY_RESORT
                    ? "Resorts"
                    : categoryType ===
                      Constants.categoryType.CATEGORY_APARTHOTEL
                    ? "Aparthotels"
                    : categoryType === Constants.categoryType.CATEGORY_ZOO ||
                      categoryType === Constants.categoryType.CATEGORY_PARKFUL
                    ? typeData?.filterName !== "All"
                      ? typeData?.filterName !== "All" &&
                        typeData?.filterName !== "Aviary" &&
                        typeData?.filterName !== "Animal sanctuary" &&
                        typeData?.filterName !== "Basic" &&
                        typeData?.filterName !== "Premium" &&
                        typeData?.filterName !== "Luxury" &&
                        typeData?.filterName !== "Best"
                        ? typeData?.filterName + "s "
                        : typeData?.filterName
                            ?.replace("Aviary", "Aviaries")
                            ?.replace(
                              "Animal sanctuary",
                              "Animal sanctuaries"
                            ) + " "
                      : categoryType === Constants.categoryType.CATEGORY_PARKFUL
                      ? "Amusement Parks"
                      : "Zoos & animal parks"
                    : "Venues"}
                </div>
              </div>
            </div>
            <div>
              <CardList
                isChartsMode={false}
                isGuides={true}
                horizontal={false}
                gridView={false}
                items={items.length > 0 ? items : listData}
                category={categoryType}
                style={{ marginTop: 16 }}
                // onItemAction={({ type, item }) => onItemAction({ type, item })}
                isLoadingNextPage={false}
                isLoading={false}
                isExploreSearch
                isMobileVersion={isMobileVersion}
                gapHeight={0}
              />
            </div>
            <div className="flex flex-row items-center justify-center">
              {isShowLoadMore && !isLoading && (
                <TouchableOpacity
                  style={
                    isMobileVersion
                      ? styles.mobileLoadMoreButtonContainer
                      : styles.loadMoreButtonContainer
                  }
                  onPress={onLoadMore}>
                  <Text
                    style={[
                      styles.buttonText,
                      isMobileVersion && { fontSize: 12, lineHeight: 12 },
                    ]}>
                    VIEW MORE
                  </Text>
                </TouchableOpacity>
              )}
              {isShowLoadMore && isLoading && (
                <div className="mt-[20px]">
                  <ActivityIndicator />
                </div>
              )}
            </div>
            {listData.length > 0 && (
              <LastUpdate
                isMobileVersion={isMobileVersion}
                updatedAt={updatedAt}
                isGuide
              />
            )}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

const styles = StyleSheet.create({
  loadMoreButtonContainer: {
    width: 180,
    height: 40,
    borderWidth: 1,
    borderColor: getClass("border-spliterLine"),
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 20,
    alignSelf: "center",
    marginTop: 18,
  },
  mobileLoadMoreButtonContainer: {
    width: 120,
    height: 32,
    borderWidth: 1,
    borderColor: getClass("border-spliterLine"),
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 20,
    alignSelf: "center",
    marginTop: 18,
  },
  buttonText: {
    color: getClass("text-white"),
    fontFamily: Fonts.primaryBold,
    fontSize: 16,
    textAlign: "center",
  },
});

export default GuideType;
